"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSeparator = exports.StyledSeparatorInner = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSeparatorInner = styled_components_1.default.div `
    position: relative;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.borders.normal};
    margin: ${({ theme }) => `${theme.spacing.s} 0 ${theme.spacing.s} 0`};
`;
exports.StyledSeparator = styled_components_1.default.tr `
    position: relative;
    display: table-row;
    > td {
        width: 100%;
    }
`;
//# sourceMappingURL=Separator.styles.js.map